/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NoteAdminDeleteReqVo
 */
export interface NoteAdminDeleteReqVo {
    /**
     * 站内信ID列表
     * @type {Array<number>}
     * @memberof NoteAdminDeleteReqVo
     */
    ids: Array<number>;
}

/**
 * Check if a given object implements the NoteAdminDeleteReqVo interface.
 */
export function instanceOfNoteAdminDeleteReqVo(value: object): value is NoteAdminDeleteReqVo {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function NoteAdminDeleteReqVoFromJSON(json: any): NoteAdminDeleteReqVo {
    return NoteAdminDeleteReqVoFromJSONTyped(json, false);
}

export function NoteAdminDeleteReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoteAdminDeleteReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function NoteAdminDeleteReqVoToJSON(json: any): NoteAdminDeleteReqVo {
    return NoteAdminDeleteReqVoToJSONTyped(json, false);
}

export function NoteAdminDeleteReqVoToJSONTyped(value?: NoteAdminDeleteReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

